export enum EIssRetido
{
    Retencao = 0,
    Normal = 1,
    Substituicao = 2
}
